export default {
    mounted() {

        // language toggle
        const formLanguageToggle = document.querySelector("[data-form-language-toggle]")

        if (formLanguageToggle) {
            const form = formLanguageToggle.closest("form")
            const labels = Array.from(form.querySelectorAll("label"))
            const originalLabelTexts = labels.map(item => item.querySelector("span").innerText)
            const selects = Array.from(document.querySelectorAll("[data-language-espanol-select]"))
            let options
            let originalOptionTexts

            // hang data on each label with original english text
            labels.forEach((item, i) => {
                item.dataset.languageEnglish = originalLabelTexts[i]
                let instructions = item.querySelector(".instructions")?.textContent;
                item.dataset.languageEnglishInstructions = instructions ? instructions : '';
            })

            // find translation options that are hung via data on any eligible select
            // convert that string into an array
            // get text from all original option elements
            // hang data on options with original and spanish text
            selects.forEach(select => {
                const string = select.dataset.languageEspanolOptions
                const explode = string.split(",")
                const optionsTranslated = explode.map(item => item.trim())
                const optionsNative = Array.from(select.querySelectorAll("option"))

                const originalOptTexts = optionsNative.map(option => option.innerText.trim())

                optionsNative.forEach((item, i) => {
                    item.dataset.languageEnglish = originalOptTexts[i]
                    item.dataset.languageEspanol = optionsTranslated[i]
                })

                options = optionsNative
                originalOptionTexts = originalOptTexts
            })

            function changeLanguage(labels, options, language) {
                labels.forEach((item, i) => {
                    console.log("Instructions Class Text: ", item.getAttribute(`data-language-${language}-instructions`))

                    if (!("formLanguageToggleLabel" in item.dataset)) {
                        item.querySelector("span").innerText = item.getAttribute(`data-language-${language}`) ? item.getAttribute(`data-language-${language}`) : originalLabelTexts[i]
                        if (item.querySelector(".instructions")) {
                            item.querySelector(".instructions").innerText = item.getAttribute(`data-language-${language}-instructions`);
                        }
                    }
                });


                if (options) {
                    options.forEach((item, i) => {
                        item.innerText = item.getAttribute(`data-language-${language}`) ? item.getAttribute(`data-language-${language}`) : originalOptionTexts[i]
                    })
                }
            }

            function selectLanguage() {
                const result = formLanguageToggle.value.toLowerCase()
                changeLanguage(labels, options, result)
            }

            function espanolByDefault() {
                const isReferred = document.referrer.includes("https://es.breezeline.com/") || document.referrer.includes("/my-services/es-seasonal")
                const isTranslated = window.location.href.indexOf("/my-services/es-seasonal") !== -1
                const referralLanguage = 'espanol'

                if (isReferred || isTranslated) {
                    formLanguageToggle.value = referralLanguage
                    changeLanguage(labels, options, referralLanguage)
                }
            }
            formLanguageToggle.addEventListener("change", selectLanguage)
            espanolByDefault();
        }
    }
}

